import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from "rxjs/Observable";
import * as moment from 'moment';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import { IUserWeeklyTimesheet } from '../../../../typings/api';
import { IActivity, IUser } from '../../../../typings/timetracker/timetracker';
import { TimeTrackerBaseApi } from '../../../providers/generic.service';


export interface IActivity {
    hours: number;
    correction: number;
    id: number;
    label: string;
    day: number;
}

@Injectable()
export class TimesheetService {

    public selectedUser$         = new BehaviorSubject<IUser>(undefined);
    public selectedTimesheet$    = new BehaviorSubject<IUserWeeklyTimesheet>(undefined);
    public availableActivities$  = new BehaviorSubject<IActivity[]>(undefined);
    public USER_STORAGE_LABEL  = 'vvu-selected-user';
    public WEEK_STORAGE_LABEL  = 'vvu-selected-iso-week';
    public YEAR_STORAGE_LABEL  = 'vvu-selected-year';

    setSelectedUser( user: IUser ): void {
        if ( window && window.localStorage && user ) {
            window.localStorage.setItem( this.USER_STORAGE_LABEL, `${user.id}` );
        }
        this.selectedUser$.next( user );
    }

    getSelectedUser(): Observable<IUser> {
        return this.selectedUser$.asObservable();
    }

    getSelectTimesheetFetch(): Observable<IUserWeeklyTimesheet> {
        return this.selectedTimesheet$.asObservable();
    }

    getStoredTimesheetData(): { userId:number, isoWeek:number, year:number } {
        if ( window && window.localStorage ) {
            return {
                userId: parseInt( window.localStorage.getItem( this.USER_STORAGE_LABEL ), 10 ),
                isoWeek: parseInt( window.localStorage.getItem( this.WEEK_STORAGE_LABEL ), 10 ),
                year: parseInt( window.localStorage.getItem( this.YEAR_STORAGE_LABEL ), 10 )
            }
        }
        else {
            return { userId: undefined, isoWeek: undefined, year: undefined };
        }
    }

    dispatchApproveTimesheet( isoWeek: number, year: number, userId: number, approve: boolean = true ) {
        this.$api.genericPutCall( `/admin/timesheets/${userId}/${year}/${isoWeek}?approved=` + approve ).subscribe( ( response ) => {
            this.dispatchSelectTimesheetFetch( userId, isoWeek, year );
        } );
    }

    /**
     * Delete a specific correction for a user
     *
     * @param correctionId
     * @param userId
     * @param isoWeek
     * @param year
     */
    dispatchDeleteCorrection( activtiyId: number, userId: number, day: number, isoWeek: number, year: number, ) {
      console.log( '[TIMESHEET] Updating (or adding) correction', activtiyId, userId, day, isoWeek, year );

      this.$api.genericDeleteCall( '/admin/corrections', {
        user_id: userId,
        activity_id: activtiyId,
        correction_year: year,
        correction_iso_week: isoWeek,
        correction_iso_weekday: day,
      } )
      .subscribe( () => {
          this.dispatchSelectTimesheetFetch( userId, isoWeek, year );
      } )
    }

    dispatchUpdateCorrection( activtiyId: number, userId: number, day: number, isoWeek: number, year: number, duration: number ) {
        console.log( '[TIMESHEET] Updating (or adding) correction', activtiyId, userId, day, isoWeek, year );
        this.$api.genericPostCall( '/admin/corrections', {
            user_id: userId,
            activity_id: activtiyId,
            correction_year: year,
            correction_iso_week: isoWeek,
            correction_iso_weekday: day,
            duration: `${duration} hours`,
            corrected_by: 3,
            corrected_at: moment().format()
        } ).subscribe( () => {
            this.dispatchSelectTimesheetFetch( userId, isoWeek, year );
        } )
    }

    /**
     * Select Timesheet by useId and weekNumber
     * @param {number} userId  User ID to select
     * @param {number} isoWeek The ISO week number to select
     * @param {number} year    The ISO year number to select
     */
    dispatchSelectTimesheetFetch( userId: number, isoWeek: number, year: number ): void {

        console.log( '[TIMESHEET-SERVICE] Retrieving timesheet', userId, isoWeek, year );

        this.$api.genericGetCall( `/admin/timesheets/${userId}/${year}/${isoWeek}` )
        .subscribe( ( response ) => { this.selectedTimesheet$.next( response as IUserWeeklyTimesheet ) } );
    }

    storeSelectedWeek( year: number, isoWeek: number ) {
      if ( window && window.localStorage ) {
        if ( isoWeek && year ) {
            console.log( '[TIMESHEET-SERVICE] Storing iso week in local storage', isoWeek, year );
            window.localStorage.setItem( this.WEEK_STORAGE_LABEL, `${isoWeek}` );
            window.localStorage.setItem( this.YEAR_STORAGE_LABEL, `${year}` );
        }
      }
    }

    constructor( private $api: TimeTrackerBaseApi ) {

        console.log( '[TIMESHEET] Creating timesheet service istance' );
        // Retrieve all activities
        //
        this.$api.genericListCall( '/admin/activities', 100, 0 ).subscribe( ( response: any ) => {
            this.availableActivities$.next( response.items as IActivity[] );
        } );
    }
}




// WEBPACK FOOTER //
// ./src/pages/timesheets/providers/timesheet.service.ts